export default {
  install(Vue, options) {
    Vue.prototype.timestampToTime = function (timestamp) {
      var date = new Date(timestamp * 1000);
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = date.getDate() + ' ';
      var h = date.getHours() + ':';
      var m = date.getMinutes() + ':';
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    };

    Vue.prototype.getImageUrl = function (url) {

      return this.GLOBAL.BASE_URL + url
    };
    Vue.prototype.formatSeconds = function (value) {
      if (value > 0) {
        var theTime = parseInt(value);// 秒
        var middle = 0;// 分
        var hour = 0;// 小时

        if (theTime > 60) {
          middle = parseInt(theTime / 60);
          theTime = parseInt(theTime % 60);
          if (middle > 60) {
            hour = parseInt(middle / 60);
            middle = parseInt(middle % 60);
          }
        }
        var result = "" + parseInt(theTime) + "秒";
        if (middle > 0) {
          result = "" + parseInt(middle) + "分" + result;
        }
        if (hour > 0) {
          result = "" + parseInt(hour) + "小时" + result;
        }
        return result;
      } else {
        return 0;
      }

    };

    Vue.prototype.format = function (date, format){
      if (typeof date == 'string') {
        if(date.indexOf('T')>=0){
          date = date.replace('T',' ')
        }
        date = new Date(Date.parse(date.replace(/-/g, "/")))
      }
      var o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
          "q+": Math.floor((date.getMonth() + 3) / 3),
          "S": date.getMilliseconds()
      };
      var w = [
          ['日', '一', '二', '三', '四', '五', '六'],
          ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
          ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      ];
      if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      if (/(w+)/.test(format)) {
          format = format.replace(RegExp.$1, w[RegExp.$1.length - 1][date.getDay()]);
      }
      for (var k in o) {
          if (new RegExp("(" + k + ")").test(format)) {
              format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
          }
      }
      return format;
    }
    
  


  }

}
// export function format(date, format){
//   if (typeof date == 'string') {
//     if(date.indexOf('T')>=0){
//       date = date.replace('T',' ')
//     }
//     date = new Date(Date.parse(date.replace(/-/g, "/")))
//   }
//   var o = {
//       "M+": date.getMonth() + 1,
//       "d+": date.getDate(),
//       "h+": date.getHours(),
//       "m+": date.getMinutes(),
//       "s+": date.getSeconds(),
//       "q+": Math.floor((date.getMonth() + 3) / 3),
//       "S": date.getMilliseconds()
//   };
//   var w = [
//       ['日', '一', '二', '三', '四', '五', '六'],
//       ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
//       ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
//   ];
//   if (/(y+)/.test(format)) {
//       format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
//   }
//   if (/(w+)/.test(format)) {
//       format = format.replace(RegExp.$1, w[RegExp.$1.length - 1][date.getDay()]);
//   }
//   for (var k in o) {
//       if (new RegExp("(" + k + ")").test(format)) {
//           format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
//       }
//   }
//   return format;
// }



// WEBPACK FOOTER //
// ./src/utils.js